import { Box } from "@mui/material"

function BackButton ({handleBack}) {
    return (
    <Box className='absolute bottom-0 left-0 w-1/12 h-auto m-3 aspect-square flex items-center justify-center cursor-pointer' onClick={handleBack}> 
        <img src={process.env.PUBLIC_URL + '/back-arrow.svg'} className="absolute inset-0 w-full h-full object-contain" alt="Back Arrow" />
        <Box className="absolute top-1/2 left-1/2 -translate-y-1/2 font-bold text-md italic">
        Back
        </Box>
    </Box>)
} 

export default BackButton;